import React from 'react'
import type { Hit, BaseHit } from 'instantsearch.js'
import { Highlight } from 'react-instantsearch'

interface HighlightHitProps<T> {
  hit: Hit<BaseHit> & T
  attribute: keyof T
  highlightedClassname?: string
}

export function HighlightHit<T>({
  highlightedClassname = 'bg-core-oxide/60 text-white',
  hit,
  attribute,
}: HighlightHitProps<T>) {
  return <Highlight classNames={{ highlighted: highlightedClassname }} hit={hit} attribute={attribute} />
}
